import { render } from "./PlayerResources.vue?vue&type=template&id=e8a7a3e0&ts=true"
import script from "./PlayerResources.vue?vue&type=script&lang=ts"
export * from "./PlayerResources.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__